import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Status class helper for production module
export function getStatusClass(status) {
  const statusClasses = {
    'Para Corte': 'bg-blue-100 text-blue-800',
    'En Corte': 'bg-amber-100 text-amber-800',
    'En Proceso': 'bg-purple-100 text-purple-800',
    'Terminado': 'bg-green-100 text-green-800',
    'Entregado': 'bg-cyan-100 text-cyan-800',
    'Cancelado': 'bg-red-100 text-red-800',
    'Pendiente': 'bg-gray-100 text-gray-800',
  };
  return statusClasses[status] || 'bg-gray-100 text-gray-800';
}

// Date formatting helper
export function formatDate(dateString) {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-PE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch {
    return '-';
  }
}

// DateTime formatting helper
export function formatDateTime(dateString) {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleString('es-PE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '-';
  }
}
